import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const DismissPinwheelPageAlert = gql`
  mutation DismissPinwheelPageAlert($input: DismissPinwheelPageAlertInput!) {
    dismissPinwheelPageAlert(input: $input) {
      ... on DismissPinwheelPageAlertSuccess {
        id
        __typename
        alertsDismissed
      }
      ... on DismissPinwheelPageAlertError {
        __typename
        ...error
      }
    }
  }
  ${error}
`;

export default DismissPinwheelPageAlert;
